import React, { useEffect, useRef, useState } from 'react'
import { FormattedMessage } from 'react-intl'

const OPENAPI_URL = '/api/v1/openapi.json'

const ApiDocsPage: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null)
  const scriptLoaded = useRef(false)
  const [widgetLoading, setWidgetLoading] = useState(true)

  useEffect(() => {
    if (scriptLoaded.current) return
    scriptLoaded.current = true

    // Load Scalar API Reference from CDN
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = 'https://cdn.jsdelivr.net/npm/@scalar/api-reference@latest/dist/style.min.css'
    document.head.appendChild(link)

    const script = document.createElement('script')
    script.src = 'https://cdn.jsdelivr.net/npm/@scalar/api-reference@latest/dist/browser/standalone.min.js'
    script.async = true
    script.onload = () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const win = window as unknown as Record<string, any>
      if (containerRef.current && win.ScalarApiReference) {
        win.ScalarApiReference.mount(containerRef.current, {
          url: OPENAPI_URL,
          theme: 'default',
          layout: 'modern',
          darkMode: false,
        })
      }
      setWidgetLoading(false)
    }
    script.onerror = () => setWidgetLoading(false)
    document.body.appendChild(script)

    return () => {
      document.head.removeChild(link)
      document.body.removeChild(script)
    }
  }, [])

  return (
    <div className="min-h-screen">
      <div className="border-b border-border bg-background-alt px-6 py-4">
        <h1 className="text-xl font-semibold text-foreground">
          <FormattedMessage id="apiDocs.title" />
        </h1>
        <p className="text-sm text-foreground-muted">
          <FormattedMessage id="apiDocs.subtitle" />
        </p>
      </div>
      {widgetLoading && (
        <p className="px-6 py-8 text-sm text-foreground-muted">
          <FormattedMessage id="apiDocs.loading" />
        </p>
      )}
      {/* Third-party API reference widget; its content (the OpenAPI spec) is
          developer reference material, exempt from UI localization. */}
      <div ref={containerRef} id="scalar-api-reference" />
    </div>
  )
}

export default ApiDocsPage
